import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconPhone: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconPhone"><Path fillRule="evenodd" clipRule="evenodd" d="M5 23V1H19V23H5ZM9 18V20H15V18H9Z" fill="currentColor"/></CentralIconBase>;
});

export default IconPhone;
